import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from '../../../../models/Offset';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import { MatDialog } from '@angular/material/dialog';
import {RateCardModel} from '../../../../models/RateCardModel';
import {RateTypeFilterComponent} from '../../../general-components/filter/rate-type-filter/rate-type-filter.component';
import {RoleAnagrafFilterComponent} from '../../../general-components/filter/role-anagraf-filter/role-anagraf-filter.component';
import {RateCardService} from '../service-rate-card/rate-card.service';
import {RateTypeAnagrafService} from '../../../general-services/service-rate-type/rate-type-anagraf.service';
import {RoleAnagrafService} from '../../../general-services/service-role-anagraf/role-anagraf.service';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';

@Component({
  selector: 'app-filter-rate-card',
  templateUrl: './filter-rate-card.component.html',
  styleUrls: ['./filter-rate-card.component.scss']
})
export class FilterRateCardComponent  extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() showNewEditDelete?: boolean;
  @Input() filter?: RateCardModel;
  @Input() reportSection?: boolean;

  regionData: any;

  @Output() dataFiltered = new EventEmitter<any>();

  @ViewChild(RegionFilterComponent, { static: true }) regionFilterComponent;
  @ViewChild(RoleAnagrafFilterComponent, { static: true }) roleAnagrafFilterComponent;
  @ViewChild(RateTypeFilterComponent, { static: true }) rateTypeFilterComponent;

  filterSingle: AllSettingsFilterModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  dataSource: any;
  intermittentBool: boolean;


  constructor(private loaderService: LoaderService,
              private rateCardService: RateCardService,
              private regionService: RegionService,
              private rateTypeService: RateTypeAnagrafService,
              private rolesService: RoleAnagrafService,
              private dialog: MatDialog) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    this.filter = new RateCardModel();

    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.RATE_CARD_FILTER))) {
      this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.RATE_CARD_FILTER));
    }
    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      allSettingsFilterModel).pipe();

    forkJoin([getAllRegionObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }

        }, error => {
          console.log(error);
         // this.loaderService.display(false);
        });
  }

  interceptRegionChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptRoleChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptRateTypeChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.RATE_CARD_FILTER, JSON.stringify(this.filter));
    }
    this.dataFiltered.emit(this.filter);
  }

  reset() {
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.regionFilterComponent.reset();
    this.roleAnagrafFilterComponent.reset();
    this.rateTypeFilterComponent.reset();

    sessionStorage.setItem(this.SESSION_STORAGE_LABELS.DISCOUNT_FILTER, JSON.stringify(this.filter));

    this.filterTable();
  }

  getAllFilters() {
    this.filter.region = this.regionFilterComponent.optionSelected;
    this.filter.roles = this.roleAnagrafFilterComponent.optionSelected;
    this.filter.rateType = this.rateTypeFilterComponent.optionSelected;
  }
  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.rateCardService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.rateCardService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
            //  this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  downloadTableXls() {
   this.loaderService.display(true);
    this.getAllFilters();
    this.getNameSubscribe = this.rateCardService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = new Date();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob(
              [resultPage],
              { type: this.EXCEL_TYPE }),
              'Rate Card' + ' - ' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob(
              [resultPage],
              { type: this.EXCEL_TYPE }),
              'Rate card' + ' - ' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  ngOnDestroy(): void {
  }
}
